
import DirectNormal from "../../../assets/outline/DirectNormal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectNormalIcon({ className, dataTestid = "DirectNormalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectNormal data-testid={dataTestid} className={classes} {...rest} />
  );
}
